import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import InsuranceExportedBatchesList from './InsuranceExportedBatchesList';
import { Size } from '../../../../Enums/Size.enum';
import { DocumentationFile } from '../../../../graphql/graphql';

interface Props extends BaseModalProps {
	workplaceId: string;
	rootWorkplaceId: string;
	exportFile: DocumentationFile;
}

const InsuranceExportedBatchesListModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.insuranceExportedBatchesListModal.batches'
			size={Size.FULLSCREEN}>
			<InsuranceExportedBatchesList
				workplaceId={props.workplaceId}
				rootWorkplaceId={props.rootWorkplaceId}
				exportFile={props.exportFile}
			/>
		</BaseModal>
	);
};

export default InsuranceExportedBatchesListModal;
